import { ContentCheckInsQueryKeys } from '@tabeeb/modules/checkIns/requests'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useApi } from '@tabeeb/shared/utils/API'
import { GetTrackingSnapshotRequest } from '@tabeeb/contracts/main-api/swagger-main-api'

type UseContentCheckInsProps = {
  contentId: number
  params: GetTrackingSnapshotRequest
}

const useContentCheckIns = ({ contentId, params }: UseContentCheckInsProps) => {
  const { mainApi } = useApi()

  const query = useInfiniteQuery({
    queryKey: [ContentCheckInsQueryKeys.TrackingSnapshot, contentId, params],
    enabled: !!contentId,
    queryFn: ({ pageParam = params.Skip }) => {
      const request: GetTrackingSnapshotRequest = {
        ...params,
        Skip: pageParam,
      }
      return mainApi.tracking.getSnapshotAsync(contentId, request)
    },
    getNextPageParam: (lastPage, allPages) => {
      const total = allPages?.[0]?.TotalCount ?? lastPage?.TotalCount ?? 0

      const loaded = allPages.reduce((acc, p) => {
        return acc + (p?.Users?.length ?? 0)
      }, 0)

      if (loaded >= total) {
        return undefined
      }

      return params.Skip + loaded
    },
  })

  const totalCount = query.data?.pages?.[0]?.TotalCount ?? 0

  return {
    ...query,
    checkIns: query.data || { pages: [], pageParams: [] },
    totalCount,
  }
}

export default useContentCheckIns
